type IconProps = React.ComponentProps<'svg'>

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(8.25, 5.25)">
        <path
          d="M0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L7.28022 6.21967C7.57305 6.51257 7.57309 6.98734 7.28022 7.28022L1.28022 13.2802C0.987342 13.5731 0.512568 13.5731 0.21967 13.2802C-0.0732233 12.9873 -0.0732233 12.5126 0.21967 12.2197L5.6894 6.74994L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
